import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { ApplicationError } from '@/api/ApplicationError';
import { getInitialFunnelApiState } from '@/stores/types/funnelApi';

export const useFunnelApiStore = defineStore('funnelApi', () => {
  const initial = getInitialFunnelApiState();
  const loading = ref(initial.loading);
  const error = ref(initial.error);

  const isFunnelApiSuccess = computed(() => !loading.value && !error.value);
  const isFunnelApiError = computed(() => !loading.value && !!error.value);

  const resetFunnelApiLoading = (): void => {
    loading.value = false;
  };

  const setFunnelApiLoading = (): void => {
    error.value = undefined;
    loading.value = true;
  };

  const setFunnelApiError = (runtimeError: Error): void => {
    error.value =
      runtimeError instanceof ApplicationError
        ? runtimeError
        : ApplicationError.fromRuntimeError(runtimeError);
    loading.value = false;
  };

  const resetFunnelApiStates = (): void => {
    error.value = undefined;
    loading.value = false;
  };

  return {
    loading,
    error,
    isFunnelApiSuccess,
    isFunnelApiError,
    resetFunnelApiLoading,
    setFunnelApiLoading,
    setFunnelApiError,
    resetFunnelApiStates,
  };
});
